import { Epic } from 'redux-observable';
import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import {
  reportsViewFetchDashboardRequest,
  reportsViewInit,
} from '../reportsViewSlice';
import { RootState } from '../../../../store';

type IN = ReturnType<typeof reportsViewInit>;
type OUT = ReturnType<typeof reportsViewFetchDashboardRequest>;

export const ReportsViewOnInitEpic: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(reportsViewInit.match),
    withLatestFrom(state$),
    switchMap(([, state]) => {
      return [reportsViewFetchDashboardRequest()];
    }),
  );
